export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error) return fallback;

  const responseData = error.response?.data;
  const serverMessage = responseData?.msg || responseData?.message;

  if (serverMessage) {
    return serverMessage;
  }

  if (!error.response) {
    if (error.code === 'ECONNABORTED') {
      return 'Request timed out. Please try again.';
    }
    return 'Unable to connect to the server. Please try again.';
  }

  const status = error.response.status;

  switch (status) {
    case 400:
      return 'Invalid request. Please check the entered details and try again.';
    case 401:
      return 'You are not authorized to perform this action.';
    case 403:
      return 'You are not authorized to perform this action.';
    case 404:
      return 'The requested profile was not found.';
    case 409:
      return 'This action conflicts with existing data. Please review and try again.';
    case 500:
      return 'Something went wrong while processing your request. Please try again.';
    default:
      break;
  }

  if (error.message) return error.message;
  return fallback;
};
